import type { I18nOptions } from 'vue-i18n';

const messages: I18nOptions['messages'] = {
  ru: {
    entity_preparation: {
      loading: 'Подготовка формы…',
      failed: 'Не удалось подготовить форму. Повторите загрузку.',
      refresh_failed:
        'Не удалось обновить справочники. Введённые данные сохранены.',
      retry: 'Повторить',
    },
    password_input: { show_value: 'Показывать значение' },
    entity_submit: {
      saved: 'Изменения сохранены.',
      navigation_failed: 'Не удалось открыть карточку. Повторите переход.',
      open_card: 'Открыть карточку',
    },
    organization_coordinates: {
      errors: {
        coordinates_invalid:
          'Введите широту и долготу через запятую: от −90 до 90 и от −180 до 180.',
        clipboard_failed:
          'Не удалось прочитать буфер обмена. Разрешите доступ или введите координаты вручную.',
      },
    },
    access_requests: {
      errors: {
        inn_digits_only: 'ИНН должен содержать только цифры',
      },
    },
  },
  en: {
    entity_preparation: {
      loading: 'Preparing form…',
      failed: 'Unable to prepare the form. Try loading it again.',
      refresh_failed:
        'Unable to refresh options. Your input has been preserved.',
      retry: 'Retry',
    },
    password_input: { show_value: 'Show value' },
    entity_submit: {
      saved: 'Changes saved.',
      navigation_failed: 'Unable to open the record. Try opening it again.',
      open_card: 'Open record',
    },
    organization_coordinates: {
      errors: {
        coordinates_invalid:
          'Enter latitude and longitude separated by a comma: −90 to 90 and −180 to 180.',
        clipboard_failed:
          'Unable to read the clipboard. Allow access or enter coordinates manually.',
      },
    },
    access_requests: {
      errors: {
        inn_digits_only: 'TIN must contain digits only',
      },
    },
  },
  es: {
    entity_preparation: {
      loading: 'Preparando formulario…',
      failed: 'No se pudo preparar el formulario. Vuelva a intentarlo.',
      refresh_failed:
        'No se pudieron actualizar las opciones. Sus datos se han conservado.',
      retry: 'Reintentar',
    },
    password_input: { show_value: 'Mostrar valor' },
    entity_submit: {
      saved: 'Cambios guardados.',
      navigation_failed: 'No se pudo abrir la ficha. Inténtelo de nuevo.',
      open_card: 'Abrir ficha',
    },
  },
  fr: {
    entity_preparation: {
      loading: 'Préparation du formulaire…',
      failed: 'Impossible de préparer le formulaire. Réessayez.',
      refresh_failed:
        'Impossible de mettre à jour les options. Votre saisie est conservée.',
      retry: 'Réessayer',
    },
    password_input: { show_value: 'Afficher la valeur' },
    entity_submit: {
      saved: 'Modifications enregistrées.',
      navigation_failed: 'Impossible d’ouvrir la fiche. Réessayez.',
      open_card: 'Ouvrir la fiche',
    },
  },
  pt: {
    entity_preparation: {
      loading: 'Preparando formulário…',
      failed: 'Não foi possível preparar o formulário. Tente novamente.',
      refresh_failed:
        'Não foi possível atualizar as opções. Os dados foram preservados.',
      retry: 'Tentar novamente',
    },
    password_input: { show_value: 'Mostrar valor' },
    entity_submit: {
      saved: 'Alterações salvas.',
      navigation_failed: 'Não foi possível abrir o registro. Tente novamente.',
      open_card: 'Abrir registro',
    },
  },
  kk: {
    entity_preparation: {
      loading: 'Пішін дайындалуда…',
      failed: 'Пішінді дайындау мүмкін болмады. Қайта жүктеңіз.',
      refresh_failed:
        'Анықтамалықтар жаңартылмады. Енгізілген деректер сақталды.',
      retry: 'Қайталау',
    },
    password_input: { show_value: 'Мәнді көрсету' },
    entity_submit: {
      saved: 'Өзгерістер сақталды.',
      navigation_failed: 'Карточканы ашу мүмкін болмады. Қайта көріңіз.',
      open_card: 'Карточканы ашу',
    },
  },
  vi: {
    entity_preparation: {
      loading: 'Đang chuẩn bị biểu mẫu…',
      failed: 'Không thể chuẩn bị biểu mẫu. Vui lòng thử lại.',
      refresh_failed:
        'Không thể cập nhật danh mục. Dữ liệu đã nhập được giữ lại.',
      retry: 'Thử lại',
    },
    password_input: { show_value: 'Hiển thị giá trị' },
    entity_submit: {
      saved: 'Đã lưu thay đổi.',
      navigation_failed: 'Không thể mở hồ sơ. Vui lòng thử lại.',
      open_card: 'Mở hồ sơ',
    },
  },
  zh: {
    entity_preparation: {
      loading: '正在准备表单…',
      failed: '无法准备表单，请重试。',
      refresh_failed: '无法更新选项，已保留输入的数据。',
      retry: '重试',
    },
    password_input: { show_value: '显示内容' },
    entity_submit: {
      saved: '更改已保存。',
      navigation_failed: '无法打开详情，请重试。',
      open_card: '打开详情',
    },
  },
  uz: {
    entity_preparation: {
      loading: 'Shakl tayyorlanmoqda…',
      failed: 'Shaklni tayyorlab bo‘lmadi. Qayta yuklang.',
      refresh_failed:
        'Ma’lumotnomalar yangilanmadi. Kiritilgan ma’lumotlar saqlandi.',
      retry: 'Qayta urinish',
    },
    password_input: { show_value: 'Qiymatni ko‘rsatish' },
    entity_submit: {
      saved: 'O‘zgarishlar saqlandi.',
      navigation_failed: 'Kartochkani ochib bo‘lmadi. Qayta urinib ko‘ring.',
      open_card: 'Kartochkani ochish',
    },
  },
  he: {
    entity_preparation: {
      loading: 'הטופס בהכנה…',
      failed: 'לא ניתן להכין את הטופס. יש לנסות שוב.',
      refresh_failed: 'לא ניתן לעדכן את האפשרויות. הנתונים שהוזנו נשמרו.',
      retry: 'ניסיון חוזר',
    },
    password_input: { show_value: 'הצגת הערך' },
    entity_submit: {
      saved: 'השינויים נשמרו.',
      navigation_failed: 'לא ניתן לפתוח את הרשומה. יש לנסות שוב.',
      open_card: 'פתיחת הרשומה',
    },
  },
};

const options: I18nOptions = {
  legacy: false,
  locale: 'ru',
  fallbackLocale: 'en',
  messages,
  missingWarn: false,
  fallbackWarn: false,
};
export default defineI18nConfig(() => options);
